module.exports = __webpack_public_path__ + "media/thanos_dust_3.94ca0f5b.mp3";